import { useEffect } from "react";
import { Routes, Route, useNavigate } from "react-router-dom";
import { User } from "oidc-client-ts";

import { EmployerApiProvider } from "@sentara-health/sentara-api-hooks-core";

import { NonSecuredRoutes, SecuredRoutes } from "./";
import {
  useGlobalState,
  useAuth,
  useBranding,
  OidcAuthProvider,
  Brands,
} from "providers";
import { ProtectedRoute } from "organisms/protectedRoute";
import { oidcConfig } from "organisms/auth";
import { APPLICATION_TYPE } from "utils/constants/Constants";

export const AppRoutes = () => {
  const { ENVTYPES } = useGlobalState();
  const { BASE_URL: baseURL, OPC_APIM_SUB_KEY: OcpApimSubscriptionKey } =
    ENVTYPES;
  const { token } = useAuth();
  const navigate = useNavigate();
  const { brandConfig } = useBranding();

  const themeClass =
    brandConfig.brandName === Brands.AVMED ? "avmed-theme" : "shp-theme";

  const adfsName = brandConfig.adfsName?.length
    ? brandConfig.adfsName
    : brandConfig.brandName;

  const tokenEndpointWithBrandName =
    oidcConfig.metadata.token_endpoint +
    "&brand=" +
    adfsName +
    "&type=" +
    APPLICATION_TYPE;

  const _oidcConfig = {
    ...oidcConfig,
    metadata: {
      ...oidcConfig.metadata,
      token_endpoint: tokenEndpointWithBrandName,
    },
    client_id: brandConfig.oidcConfig.client_id,
    client_secret: brandConfig.oidcConfig.client_secret,
    onSigninCallback: (_user: User | void): void => {
      navigate("/");
    },
  };

  useEffect(() => {
    const isAvmedFlag = brandConfig.brandName === Brands.AVMED;
    if (isAvmedFlag) {
      document.documentElement.style.setProperty(
        "--font-family-medium",
        "'Poppins_medium', Arial, Helvetica, sans-serif",
      );
      document.documentElement.style.setProperty(
        "--font-family-bold",
        "'Poppins_bold', Arial, Helvetica, sans-serif",
      );
      document.documentElement.style.setProperty(
        "--font-family-semibold",
        "'Poppins_semibold', Arial, Helvetica, sans-serif",
      );
      document.documentElement.style.setProperty(
        "--font-family-regular",
        "'Poppins_body', Arial, Helvetica, sans-serif",
      );
      document.documentElement.style.setProperty(
        "--font-family",
        "'Poppins_body', Arial, Helvetica, sans-serif",
      );
      document.documentElement.style.setProperty(
        "--body-text-color",
        "#171717",
      );
    } else {
      document.documentElement.style.setProperty(
        "--font-family-regular",
        "'RedHatDisplay_body', Arial, Helvetica, sans-serif",
      );
      document.documentElement.style.setProperty(
        "--body-text-color",
        "#000000",
      );
    }
  }, []);

  return (
    <OidcAuthProvider {..._oidcConfig}>
      <EmployerApiProvider
        httpConfig={
          token
            ? {
                baseURL,
                commonHeaders: {
                  "Ocp-Apim-Subscription-Key": OcpApimSubscriptionKey,
                  Authorization: `Bearer ${token}`,
                },
              }
            : {}
        }
      >
        <div className={themeClass}>
          <Routes>
            <Route path="/*" element={<NonSecuredRoutes />} />
            <Route
              path="/app/*"
              element={
                <ProtectedRoute>
                  <SecuredRoutes />
                </ProtectedRoute>
              }
            />
          </Routes>
        </div>
      </EmployerApiProvider>
    </OidcAuthProvider>
  );
};
